export const SAT_SET_USER = "SAT_SET_USER";
export const SAT_SET_GUEST = "SAT_SET_GUEST";
export const SAT_SET_GUEST_PREVIEW = "SAT_SET_GUEST_PREVIEW";
